import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";

import { WalletPage } from "../wallet/wallet";

@Component({
  selector: "page-help-modal",
  templateUrl: "help-modal.html"
})
export class HelpModalPage {
  title: string;
  description: string;
  seed: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    this.title = this.navParams.get("title");
    this.description = this.navParams.get("description");
    this.seed = this.navParams.get("seed");
    console.log("title ", this.title, " desc ", this.description);
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad HelpModalPage");
  }

  goBack() {
    this.viewCtrl.dismiss(false);
  }

  goSeeds() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/help-modal/help-modal.ts